/* eslint-disable */
import React, { useCallback, useRef } from 'react';
import WhyStudentTargetHero from '../WhyStudentTargetHero';
import WhyStudentTargetReasons, {
  IWhyStudentTargetReasonItem,
} from '../WhyStudentTargetReasons';
import './index.less';

export type IWhyStudentTargetItem = IWhyStudentTargetReasonItem;

export interface IWhyStudentTargetContentProps {
  title?: string;
  description?: string;
  items?: IWhyStudentTargetItem[];
  backgroundImage?: string;
  id?: string;
  onComplete?: () => void;
}

const WhyStudentTargetContent: React.FunctionComponent<
  IWhyStudentTargetContentProps
> = ({ title, description, items = [], backgroundImage, id, onComplete }) => {
  const completedRef = useRef(false);
  const reasonsRef = useRef<HTMLDivElement>(null);

  const markComplete = useCallback(() => {
    if (completedRef.current) return;
    completedRef.current = true;
    onComplete?.();
  }, [onComplete]);

  const handleArrowClick = useCallback(() => {
    markComplete();
    reasonsRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  }, [markComplete]);

  if (!items.length && !title && !description && !backgroundImage) return null;

  return (
    <div className="why-student-training-target-content" id={id}>
      <WhyStudentTargetHero
        title={title}
        description={description}
        backgroundImage={backgroundImage}
        onArrowClick={handleArrowClick}
      />
      <WhyStudentTargetReasons
        ref={reasonsRef}
        items={items}
        className="why-student-training-target-content-reasons"
        onComplete={markComplete}
      />
    </div>
  );
};

export default React.memo(WhyStudentTargetContent);
